import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  input,
  NgZone,
  OnInit,
  viewChild,
} from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { LanguagePopupService } from '../language-popup/language-popup.service';
import { StateService } from '../../services/state.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { interval } from 'rxjs';
import { IS_BROWSER } from '../../providers/is-platform.provider';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AddLocalePipe } from '../../pipes/url-locale.pipe';
import { TranslateRoutePipe } from '../../pipes/translate-route.pipe';
import { topBars } from '../../pages/home/mocks/topbar-content';
import { CountdownTimerComponent } from '../countdown-timer/countdown-timer.component';

@Component({
  selector: 'app-top-bar',
  imports: [
    ButtonComponent,
    AsyncPipe,
    TranslocoDirective,
    SvgIconComponent,
    RouterLink,
    AddLocalePipe,
    TranslateRoutePipe,
    NgClass,
    CountdownTimerComponent,
  ],
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'type()',
  },
})
export class TopBarComponent implements OnInit {
  private readonly languagePopupService = inject(LanguagePopupService);
  private readonly isBrowser = inject(IS_BROWSER);
  private readonly destroyRef = inject(DestroyRef);
  private readonly ngZone = inject(NgZone);
  readonly stateService = inject(StateService);

  readonly locale = input.required<string>();
  readonly topBarContent =
    viewChild.required<ElementRef<HTMLDivElement>>('topBarContent');

  readonly topbar = computed(() => topBars[this.locale()]);
  readonly type = computed(() => this.topbar().type);

  ngOnInit(): void {
    if (this.isBrowser && this.type() === 'multi') {
      this.ngZone.runOutsideAngular(() => {
        interval(8000)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            this.onClickNext();
          });
      });
    }
  }

  onClickNext(): void {
    this.changeSlide(1);
  }

  onClickPrev(): void {
    this.changeSlide(-1);
  }

  onOpenLanguagePopup(): void {
    this.languagePopupService.openSlideIn();
  }

  private changeSlide(step: number): void {
    const slides = this.topBarContent().nativeElement.querySelectorAll('.slide');
    const activeIndex = Array.from(slides).findIndex((slide) =>
      slide.classList.contains('active'),
    );

    const newIndex = (activeIndex + step + slides.length) % slides.length;

    slides[activeIndex].classList.remove('active');
    slides[newIndex].classList.add('active');
  }
}
